// extracted by mini-css-extract-plugin
export var bodyFooterButton = "RequestBrochureModalForm-module--body-footer-button--a14a9";
export var disclaimerText = "RequestBrochureModalForm-module--disclaimer-text--03199";
export var extraFieldsContainer = "RequestBrochureModalForm-module--extra-fields-container--effd2";
export var form = "RequestBrochureModalForm-module--form--f747f";
export var formFields = "RequestBrochureModalForm-module--form-fields--1e25c";
export var inputContainer2Cols = "RequestBrochureModalForm-module--input-container-2-cols--65368";
export var inputTitleContainer = "RequestBrochureModalForm-module--input-title-container--55d8d";
export var requiredFieldsLabel = "RequestBrochureModalForm-module--required-fields-label--70578";